// 3rd party imports
import * as React from 'react';

// ui
import { LocalizedText, useLocalization } from '@shared-ui/localization-context';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkTabs, UitkTab, UitkTabsType } from 'uitk-react-tabs';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkFigure, UitkImage, UitkImageLink } from 'uitk-react-images';
import { useDialog } from '@shared-ui/dialog-context';
import { UitkSheet, UitkSheetContent } from 'uitk-react-sheet';
import { UitkTransparentToolbar } from 'uitk-react-toolbar';

function Products() {
  const { useState, useRef } = React;
  const [currentTab, setCurrentTab] = useState<number>(0);
  const l10n = useLocalization();

  const triggerRef = useRef();
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog('imgDialog');
  const [imgSrc, setImgSrc] = useState('');

  const openDialog = (src) => {
    setImgSrc(src);
    dialogActions.openDialog();
  };

  const closeDialog = () => {
    setImgSrc(null);
    dialogActions.closeDialog();
  };

  const linksImgSrc = '../images/home/UI_Links.png';
  const searchWidgetImgSrc = '../images/home/UI_SearchWidget.png';
  const bannersImgSrc = '../images/home/UI_Banners.png';

  return (
    <div className="Products container">
      <DialogComponent>
        <UitkSheet isVisible={isDialogOpen} type="full" triggerRef={triggerRef} theme="dark">
          <UitkTransparentToolbar
            overlay={true}
            navigationContent={{
              onClick: closeDialog,
              navIconLabel: l10n.formatText('common.dialog.close'),
            }}
          />
          <UitkSheetContent>
            <UitkFigure imageFit="contain">
              <UitkImage src={imgSrc} />
            </UitkFigure>
          </UitkSheetContent>
        </UitkSheet>
      </DialogComponent>
      <UitkSpacing padding={{ blockend: 'six' }}>
        <UitkHeading tag="h2" size={3}>
          <LocalizedText message="home.products.heading.all_tools_you_need" />
        </UitkHeading>
      </UitkSpacing>
      <UitkTabs
        selectedTab={currentTab}
        onTabSelect={(selectedTab) => setCurrentTab(selectedTab)}
        withBorder={false}
        tabsType={UitkTabsType.NATURAL}
        centerAlign={true}
      >
        <UitkTab name={l10n.formatText('products.links.title')} id="links" tabLinkAttr={{ id: 'Tab-1' }}>
          <UitkSpacing padding={{ block: 'six' }}>
            <UitkLayoutGrid columns={{ medium: ['1fr', '2fr'], small: ['1fr'] }} space="twelve" alignItems="center">
              <UitkLayoutGridItem>
                <div>
                  <UitkHeading size={4} tag="h2">
                    <LocalizedText message="products.links.title" />
                  </UitkHeading>
                  <UitkText spacing="two">
                    <LocalizedText message="home.products.deeplinks.description" />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <UitkFigure imageFit="contain" className="Products__image">
                  <UitkImage alt="Links preview" src={linksImgSrc} />
                  <UitkImageLink>
                    <button onClick={() => openDialog(linksImgSrc)}>View image</button>
                  </UitkImageLink>
                </UitkFigure>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkSpacing>
        </UitkTab>
        <UitkTab name={l10n.formatText('products.search.title')} id="search-widget">
          <UitkSpacing padding={{ block: 'six' }}>
            <UitkLayoutGrid columns={{ medium: ['1fr', '2fr'], small: ['1fr'] }} space="twelve" alignItems="center">
              <UitkLayoutGridItem>
                <div>
                  <UitkHeading size={4} tag="h2">
                    <LocalizedText message="products.search.title" />
                  </UitkHeading>
                  <UitkText spacing="two">
                    <LocalizedText message="home.products.search-widget.description" />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <UitkFigure imageFit="contain" className="Products__image">
                  <UitkImage alt="Search Widget preview" src={searchWidgetImgSrc} />
                  <UitkImageLink>
                    <button onClick={() => openDialog(searchWidgetImgSrc)}>View image</button>
                  </UitkImageLink>
                </UitkFigure>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkSpacing>
        </UitkTab>
        <UitkTab name={l10n.formatText('products.banners.title')} id="banners">
          <UitkSpacing padding={{ block: 'six' }}>
            <UitkLayoutGrid columns={{ medium: ['1fr', '2fr'], small: ['1fr'] }} space="twelve" alignItems="center">
              <UitkLayoutGridItem>
                <div>
                  <UitkHeading size={4} tag="h2">
                    <LocalizedText message="products.banners.title" />
                  </UitkHeading>
                  <UitkText spacing="two">
                    <LocalizedText message="home.products.banners.description" />
                  </UitkText>
                </div>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem>
                <UitkFigure imageFit="contain" className="Products__image">
                  <UitkImage alt="Banners preview" src={bannersImgSrc} />
                  <UitkImageLink>
                    <button onClick={() => openDialog(bannersImgSrc)}>View image</button>
                  </UitkImageLink>
                </UitkFigure>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </UitkSpacing>
        </UitkTab>
      </UitkTabs>
    </div>
  );
}

export { Products };
